// Indicador de carga (spinner accesible)
export default function Loader({ text = 'Lädt…' }) {
  return (
    <div className="loader" role="status" aria-live="polite">
      <span className="loader-spinner" aria-hidden="true" />
      <span>{text}</span>
    </div>
  )
}
